import React, { useContext } from 'react';
import {
    DoughnutChart,
    DoughnutChartSeriesItem,
} from 'utils/components/DoughnutChart/DoughnutChart';
import { NumberFormat } from '@instinet-analytics/core-lib';
import AppContext from 'app/AppContext';
import { VenueAnalysisAggregatedLiquidityItem } from 'widgets/venueAnalysis/venueAnalysisAggregatedData';

import './OrderLiquidityCapsuleContentPie.scss';

export function OrderLiquidityCapsuleContentPie({
    data,
}: {
    data: VenueAnalysisAggregatedLiquidityItem[];
}) {
    const { numberFormat } = useContext(AppContext);
    const chartData = toChartData(data, numberFormat);

    return (
        <div className="OrderLiquidityCapsuleContentPie">
            <DoughnutChart doughnutSize={90} data={chartData} />
        </div>
    );
}

function toChartData(
    data: VenueAnalysisAggregatedLiquidityItem[],
    numberFormat: NumberFormat
): DoughnutChartSeriesItem[] {
    return data.map((d) => ({
        id: d.liquidity.index.toString(),
        tooltip: {
            body: `${d.liquidity.name} ${
                d.percent < 1
                    ? numberFormat.n1(d.percent)
                    : numberFormat.n0(d.percent)
            }%`,
        },
        value: d.qty,
        classname: d.liquidity.className,
        segmentWidth: 44,
    }));
}
